$( document ).ready(function() {
	if (document.getElementsByTagName('nb-login')[0] == null){
		//Do nothing
	} else {
		document.getElementById('title').innerHTML = 'TRIO+';
		document.getElementsByClassName('sub-title')[0].innerHTML = 'Vezetői felület';
		document.querySelectorAll('[for="input-email"]')[0].innerHTML = 'Email';
		document.getElementById('input-email').placeholder = 'Email';
		document.querySelectorAll('[for="input-password"]')[0].innerHTML = 'Jelszó';
		document.getElementById('input-password').placeholder = 'Jelszó';
		document.getElementsByClassName('forgot-password')[0].remove();
		document.querySelectorAll('[name="rememberMe"]')[0].remove();
		document.getElementsByTagName('button')[0].innerHTML = 'Bejelentkezés'
		document.querySelectorAll('[aria-label="Register"]')[0].remove();
		document.getElementsByTagName('nb-alert')[0].remove();
		//document.getElementsByClassName('caption')[0].innerHTML = 'Ez a mező nem maradhat üresen!';
	}
});
